'use client'

import React from 'react'
import { useAuth } from '@payloadcms/ui'

export const HideLocalizer = () => {
  const { user } = useAuth<any>()

  if (!user) return null

  const isAdmin = user.role === 'Super Admin'

  // If admin, do nothing (we leave the default selector visible)
  if (isAdmin) return null

  // For non-admins: inject CSS to hide the default localizer
  return (
    <style
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `
          /* Hide the built-in admin locale selector for non-admin users */
          .localizer-button{
            display: none !important;
            visibility: hidden !important;
          }
        `,
      }}
    />
  )
}
